// src/kisiye-ozel-rapor/src/pages/PatronRutin.js
import React, { useMemo, useState } from "react";

export default function PatronRutin() {
  const [periyot, setPeriyot] = useState("hafta"); // "hafta" | "ay"

  const columns = useMemo(
    () => [
      { key: "tarih", title: "Tarih" },
      { key: "baslik", title: "Başlık" },
      { key: "deger", title: "Değer" },
      { key: "not", title: "Not" },
    ],
    []
  );

  const rows = useMemo(() => [], []);

  return (
    <div>
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ fontSize: 12, color: "#334155" }}>Periyot</div>
        <select
          value={periyot}
          onChange={(e) => setPeriyot(e.target.value)}
          style={{
            padding: "8px 10px",
            border: "1px solid #d1d5db",
            borderRadius: 8,
            fontSize: 13,
            background: "#fff",
          }}
        >
          <option value="hafta">Haftalık</option>
          <option value="ay">Aylık</option>
        </select>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8, marginTop: 10 }}>
        <div style={{ background: "#ecfeff", border: "1px dashed #67e8f9", borderRadius: 8, padding: "8px 10px" }}>
          <div style={{ color: "#0e7490" }}>Ciro</div>
          <div style={{ fontWeight: 700 }}>0</div>
        </div>
        <div style={{ background: "#ecfeff", border: "1px dashed #67e8f9", borderRadius: 8, padding: "8px 10px" }}>
          <div style={{ color: "#0e7490" }}>Maliyet</div>
          <div style={{ fontWeight: 700 }}>0</div>
        </div>
        <div style={{ background: "#ecfeff", border: "1px dashed #67e8f9", borderRadius: 8, padding: "8px 10px" }}>
          <div style={{ color: "#0e7490" }}>Net</div>
          <div style={{ fontWeight: 700 }}>0</div>
        </div>
        <div style={{ background: "#ecfeff", border: "1px dashed #67e8f9", borderRadius: 8, padding: "8px 10px" }}>
          <div style={{ color: "#0e7490" }}>Araç Kullanım</div>
          <div style={{ fontWeight: 700 }}>—</div>
        </div>
      </div>

      <div style={{ marginTop: 12, overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 700 }}>
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c.key} style={{ borderBottom: "1px solid #e5e7eb", textAlign: "left", padding: 8, fontSize: 12, color: "#334155" }}>
                  {c.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={columns.length} style={{ padding: 10, color: "#6b7280" }}>
                  Veri yok (ileride veri kaynaklarına bağlanacak).
                </td>
              </tr>
            ) : (
              rows.map((r, i) => (
                <tr key={i}>
                  {columns.map((c) => (
                    <td key={c.key} style={{ borderBottom: "1px solid #f3f4f6", padding: 8, fontSize: 13 }}>
                      {r[c.key] ?? ""}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
